import { render, staticRenderFns } from "./ProjectTasksTab.vue?vue&type=template&id=29febcce"
import script from "./ProjectTasksTab.vue?vue&type=script&lang=js"
export * from "./ProjectTasksTab.vue?vue&type=script&lang=js"
import style0 from "./ProjectTasksTab.vue?vue&type=style&index=0&id=29febcce&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports